import React from 'react';
import css from './StepContentElementWrapper.module.css';

export const StepContentElementWrapper: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    return <div className={css.wrapper}>{children}</div>;
};
